import React, { useState, useEffect } from 'react';
import api from '../config/api';
import PageNavbar from './PageNavbar';
import './Agents.css';

const Agents = () => {
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingAgent, setEditingAgent] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: ''
  });

  const fetchAgents = async () => {
    try {
      const response = await api.get('/users/agents/list');
      setAgents(response.data.agents);
    } catch (error) {
      console.error('Error fetching agents:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAgents();
  }, []);

  const resetForm = () => {
    setFormData({ name: '', phone: '', email: '' });
    setEditingAgent(null);
    setShowForm(false);
  };

  const handleEdit = (agent) => {
    setEditingAgent(agent);
    setFormData({
      name: agent.name || '',
      phone: agent.phone || '',
      email: agent.email || ''
    });
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingAgent) {
        await api.put(`/users/agents/${editingAgent.id}`, formData);
        alert('Agent updated successfully');
      } else {
        await api.post('/users/agents', formData);
        alert('Agent created successfully');
      }
      resetForm();
      fetchAgents();
    } catch (error) {
      alert(error.response?.data?.error || `Error ${editingAgent ? 'updating' : 'creating'} agent`);
    }
  };

  const handleToggleActive = async (agent) => {
    if (!window.confirm(`${agent.active ? 'Deactivate' : 'Activate'} agent "${agent.name}"?`)) return;
    try {
      await api.put(`/users/agents/${agent.id}`, { active: !agent.active });
      fetchAgents();
    } catch (error) {
      alert(error.response?.data?.error || 'Failed to update agent');
    }
  };

  return (
    <div className="agents-page">
      <PageNavbar />
      <div className="container">
        <div className="agents-header">
          <h1>Agents</h1>
          <button
            className="btn btn-primary"
            onClick={() => {
              if (showForm) resetForm();
              else setShowForm(true);
            }}
          >
            {showForm ? 'Cancel' : 'Add Agent'}
          </button>
        </div>

        {showForm && (
          <div className="card">
            <h2>{editingAgent ? 'Edit Agent' : 'Add New Agent'}</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Name *</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                    placeholder="Agent name"
                  />
                </div>
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    className="form-control"
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="e.g. 1234567890"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="agent@example.com"
                />
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button type="submit" className="btn btn-primary">
                  {editingAgent ? 'Update Agent' : 'Add Agent'}
                </button>
                {editingAgent && (
                  <button type="button" className="btn btn-secondary" onClick={resetForm}>
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>
        )}

        {loading ? (
          <div className="loading">Loading agents...</div>
        ) : (
          <div className="card">
            <h2>All Agents</h2>
            <p className="agents-hint">Active agents appear in the order form when creating or editing orders.</p>
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {agents.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="no-data">No agents yet. Click &quot;Add Agent&quot; to create one.</td>
                  </tr>
                ) : (
                  agents.map((agent) => (
                    <tr key={agent.id} className={agent.active ? '' : 'agent-inactive'}>
                      <td><strong>{agent.name}</strong></td>
                      <td>{agent.phone || '-'}</td>
                      <td>{agent.email || '-'}</td>
                      <td>
                        <span className={`status-badge ${agent.active ? 'status-active' : 'status-inactive'}`}>
                          {agent.active ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() => handleEdit(agent)}
                          style={{ padding: '5px 12px', fontSize: '14px', marginRight: '8px' }}
                        >
                          Edit
                        </button>
                        <button
                          className={`btn btn-sm ${agent.active ? 'btn-secondary' : 'btn-success'}`}
                          onClick={() => handleToggleActive(agent)}
                          style={{ padding: '5px 12px', fontSize: '14px' }}
                        >
                          {agent.active ? 'Deactivate' : 'Activate'}
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default Agents;
